module.exports = __webpack_public_path__ + "static/mobile_agile-a7ed2dcd7fdca5a8c88c55580edd1a13.svg";